import { Button, Card, CardActions, CardMedia, Container, Typography } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { WebStorageService } from "../services/WebStorageService";
import { PartnerApplicationModel } from "../models/PartnerApplicationModel";
import { PARTNERSHIP } from "../contants/constants";

export default function PartnershipProgramStep2() {
    const navigate = useNavigate();
    const webStorageService = new WebStorageService();
    let partnerApplication:PartnerApplicationModel = webStorageService.getJson(PARTNERSHIP);

    return (
        <Container>
            <Card sx={{ textAlign: "center", background: "#FEF9F8", marginX: "auto", width: "100%", boxShadow: "none", marginTop:{ xs: 10, sm: 10, md: 10}}}>
                <CardMedia sx={{ height: {xs:300, sm:550, md:550, lg:650}, marginBottom: 3 }} image="/partnership-program-congratulate-partner.jpg" />
                    <Typography variant="subtitle2" textAlign="center" marginTop={3}>
                        Hi <b>{partnerApplication.FirstName} {partnerApplication.LastName}</b>, ang aming management ay ire-review ang inyong partnership application at makikipag-ugnayan po sa inyo sa ilang sandali. 
                    </Typography>
                    <Typography variant="subtitle2" textAlign="center" marginTop={3}>
                        Ang inyong Application Reference Number ay 
                            <Typography variant="h3" sx={{letterSpacing:5, fontFamily:"Courier New", textAlign:"center", textShadow: "2px 2px 4px #000000" }}>
                                {partnerApplication.PartnerApplicationID?.toString()}
                            </Typography>    
                        
                    </Typography>
                
                
                <CardActions sx={{display:"flex", justifyContent:"space-between", marginTop: {xs:3, sm:2, md:0}, marginBottom:2}}>
                    <Button variant="outlined" sx={{display:"flex", alignItems:"center", textDecoration: "none" }} onClick={() => navigate("/order-now-step1")} size="large">
                        ORDER NOW
                    </Button>
                    <Button variant="contained" sx={{background:"#d32f2f"}} size="large" href="https://www.youtube.com/@pipoy-gas" target="_blank">
                        LEARN MORE
                    </Button>
                </CardActions>
            </Card>
        </Container>
    );
}